<div class="cookie-banner" [class.extra]="showExtra">
  <div class="cookie-content">
    <ng-container *ngIf="!showExtra">
      <b class="cookie-title">Cookie Notice</b>
      <p>We use cookies to improve our website and offer a personalised experience.</p>

      <div class="buttons">
        <button appButton name="learn-more" location="cookie-banner" (click)="showExtra = true" weight="bold">Learn More</button>
        <button appButton name="accept" location="cookie-banner" color="primary" (click)="onHide.emit()"
          data-test-id="agree-cookies">Agree</button>
      </div>
    </ng-container>

    <ng-container *ngIf="showExtra">
      <b class="cookie-title">Cookie Notice</b>
      <p>We use cookies to remember your account details, provide a secure login experience, collect statistics to
        optimize site functionality and deliver content and marketing tailored to your interests. </p>

      <p>Click <b>“Agree”</b> to accept all cookies or decline by leaving the site. You can view detailed descriptions
        of
        the types of cookies we use and find information on opt-out options in our <a
          href="https://help.picflow.com/en/articles/5538125" target="_blank" class="primary-link">Cookie Policy</a>.
      </p>

      <button appButton name="accept" location="cookie-banner" color="primary" (click)="onHide.emit()" spacing="full"
        height="3">Agree</button>
    </ng-container>
  </div>
</div>
